if (!customElements.get("size-chart-scroll-lock")) {
  class SizeChartScrollLock extends HTMLElement {
    constructor() {
      super();
      this.lockViewport = this.lockViewport.bind(this);
      this.reconcileViewportLock = this.reconcileViewportLock.bind(this);
      this.unlockViewport = this.unlockViewport.bind(this);
      this.mobileQuery = window.matchMedia("(max-width: 768px)");
    }

    connectedCallback() {
      const modal = this.closest("modal-dialog");
      if (!modal || modal === this.modal) return;

      this.disconnectModal();
      this.modal = modal;
      this.modal.addEventListener("beforeopen", this.lockViewport);
      this.modal.addEventListener("close", this.unlockViewport);
      this.mobileQuery.addEventListener("change", this.reconcileViewportLock);
    }

    disconnectedCallback() {
      this.disconnectModal();
    }

    disconnectModal() {
      if (!this.modal) return;

      this.modal.removeEventListener("beforeopen", this.lockViewport);
      this.modal.removeEventListener("close", this.unlockViewport);
      this.mobileQuery.removeEventListener(
        "change",
        this.reconcileViewportLock
      );
      this.unlockViewport();
      this.modal = undefined;
    }

    reconcileViewportLock() {
      if (!this.modal?.hasAttribute("open")) return;

      if (this.mobileQuery.matches) {
        this.lockViewport();
      } else {
        this.unlockViewport();
      }
    }

    lockViewport() {
      if (
        !this.modal ||
        !this.mobileQuery.matches ||
        this.viewportLock
      )
        return;

      const scrollY = window.scrollY;
      const viewport = window.visualViewport;
      const preventBackgroundScroll = (event) => {
        if (
          event.target instanceof Element &&
          event.target.closest(".f-modal--size-chart .f-modal__inner")
        )
          return;

        event.preventDefault();
      };
      const updateViewport = () => {
        this.modal.style.setProperty(
          "--size-chart-visual-viewport-page-top",
          `${scrollY + (viewport?.offsetTop || 0)}px`
        );
        this.modal.style.setProperty(
          "--size-chart-visual-viewport-height",
          `${viewport?.height || window.innerHeight}px`
        );
      };
      const lock = {
        scrollY,
        viewport,
        preventBackgroundScroll,
        updateViewport,
      };

      this.viewportLock = lock;
      updateViewport();
      viewport?.addEventListener("scroll", updateViewport);
      (viewport || window).addEventListener("resize", updateViewport);
      document.addEventListener("touchmove", preventBackgroundScroll, {
        passive: false,
        capture: true,
      });
      document.addEventListener("wheel", preventBackgroundScroll, {
        passive: false,
        capture: true,
      });
      document.documentElement.classList.add("size-chart-scroll-lock");
      document.body.classList.add("size-chart-scroll-lock");
      document.body.style.setProperty(
        "--size-chart-page-offset",
        `-${scrollY}px`
      );
    }

    unlockViewport() {
      if (!this.viewportLock) return;

      const {
        scrollY,
        viewport,
        preventBackgroundScroll,
        updateViewport,
      } = this.viewportLock;
      viewport?.removeEventListener("scroll", updateViewport);
      (viewport || window).removeEventListener("resize", updateViewport);
      document.removeEventListener(
        "touchmove",
        preventBackgroundScroll,
        true
      );
      document.removeEventListener("wheel", preventBackgroundScroll, true);
      document.documentElement.classList.remove("size-chart-scroll-lock");
      document.body.classList.remove("size-chart-scroll-lock");
      document.body.style.removeProperty("--size-chart-page-offset");
      this.modal?.style.removeProperty(
        "--size-chart-visual-viewport-page-top"
      );
      this.modal?.style.removeProperty("--size-chart-visual-viewport-height");
      this.viewportLock = undefined;
      window.scrollTo(0, scrollY);
    }
  }

  customElements.define("size-chart-scroll-lock", SizeChartScrollLock);
}
